/**
 * Gramática's exercise card.
 *
 * The faces are shared with Grammatik — see
 * `src/apps/shared/grammar/CardFront.tsx`. This file supplies the adapter and
 * the course, so a fix to how an exercise is drilled lands in both languages.
 */
import { useEffect, useRef } from 'react';

import { GrammarCardFront } from '../shared/grammar/CardFront';
import type { CardFrontProps } from '../types';

import { gramaticaCourse, toExercise } from './course';
import type { GramaticaPayload } from './types';

export function CardFront({ card, onAnswer }: CardFrontProps<GramaticaPayload>) {
  const startRef = useRef<number>(Date.now());

  useEffect(() => {
    startRef.current = Date.now();
  }, [card.id]);

  return (
    <GrammarCardFront
      exercise={toExercise(card.payload)}
      course={gramaticaCourse}
      cardKey={card.id}
      onAnswer={(correct, userAnswer) =>
        onAnswer({ correct, user_answer: userAnswer, time_ms: Date.now() - startRef.current })
      }
    />
  );
}
